import { render, staticRenderFns } from "./viewInvoice.vue?vue&type=template&id=73dc796b&"
import script from "./viewInvoice.vue?vue&type=script&lang=js&"
export * from "./viewInvoice.vue?vue&type=script&lang=js&"
import style0 from "./viewInvoice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSimpleTable,VTextField})
